import { render, staticRenderFns } from "./HairLoader.vue?vue&type=template&id=63412f22&"
import script from "./HairLoader.vue?vue&type=script&lang=js&"
export * from "./HairLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports